import type { ReactNode } from 'react'
import React from 'react'

import Tooltip from '../Tooltip/Tooltip'
import { StyledQuestionMark } from './Infotip.styles'

export interface InfotipProps {
  'data-e2e'?: string
  helpText: ReactNode
}

const Infotip = ({ 'data-e2e': dataE2e, helpText }: InfotipProps) => (
  <Tooltip data-e2e={`${dataE2e}--tooltip`} placement="top" tooltip={helpText} variant="black">
    <StyledQuestionMark data-e2e={dataE2e}>?</StyledQuestionMark>
  </Tooltip>
)

export default Infotip
